import api from '@/util/app-api'

class AppSettingsService {
  getLandingSettings(customerCode) {
    return api.get('appSettings/GetLandingSettings/' + customerCode, {}, { authHeader: false })
  }

  getThemeSettings(customerCode) {
    return api.get('appSettings/GetThemeSettings/' + customerCode, {}, { authHeader: false })
  }

  getSettings() {
    return api.get('admin/appSettings/get')
  }

  updateSettings(settings) {
    return api.post('admin/appSettings/edit', settings)
  }

  getSettingsForMemberPanel() {
    return api.get('member/appSettings/get')
  }

  getSettingsForAgentPanel() {
    return api.get('agent/appSettings/get')
  }

  getSettingsForSponsorPanel() {
    return api.get('sponsor/appSettings/get')
  }

  getSiteConfig() {
    return api.post('site/siteConfig', null, { authHeader: false })
  }

  updateMemebrSettings(settings) {
    return
  }

  updateAgentSettings(settings) {
    return
  }

  updateSponsorSettings(settings) {
    return
  }
}

export default new AppSettingsService()
